import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  sendRequest,
  selectItemsIds,
  selectRequestState,
  selectPagination,
  changeQueryParams
} from 'mt-react-common/common/reducers/list/reducer';
import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';
import { t } from 'utils/translates';

import PaginationBlock from '../../Common/Pagination/PaginationBlock/index';
import MediumPreLoader from '../../Common/PreLoaders/MediumPreLoader';
import TaskItemAsOwner from './TaskItemAsOwner';
import TasksHeaderSort from '../TasksHeaderSort/TasksHeaderSort';

const tasksCollectionRName = 'tasksModule.collections.tasksCollection';

// eslint-disable-next-line react/prefer-stateless-function
class TasksListAsOwner extends Component {
  render() {
    let comments = null;
    if (this.props.requestStatus.inProgress) {
      comments = <MediumPreLoader />;
    } else if (this.props.itemsIds.length > 0) {
      comments = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            <TaskItemAsOwner
              key={`taskItemAsOwner${itemId}`}
              task={this.props.selectItemById(itemId)}
            />
          ))}
          <PaginationBlock
            paginationData={this.props.pagination}
            handlePageClick={pageNumber => {
              this.props.changeQueryParams({ page: pageNumber });
              this.props.sendRequest();
            }}
          />
        </React.Fragment>
      );
    } else {
      comments = (
        <div className="alert alert-default alert_padding-lg text-center">
          <i
            className="fa fa-2x fa-info-circle m-b-10 m-t-5"
            aria-hidden="true"
          />
          <h4>{t('Здесь пока ничего нет')}</h4>
          <p>
            {t(
              'Чтобы добавить задание, нажмите кнопочку «Создать задание» и заполните форму!'
            )}
          </p>
        </div>
      );
    }

    return (
      <React.Fragment>
        <TasksHeaderSort listReduceName={this.props.reducerName} />
        {comments}
      </React.Fragment>
    );
  }
}

TasksListAsOwner.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  reducerName: PropTypes.string.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestStatus: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  sendRequest: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestStatus: selectRequestState(state, props.reducerName),
  pagination: selectPagination(state, props.reducerName),
  itemsIds: selectItemsIds(state, props.reducerName),
  selectItemById: id => selectItemById(state, tasksCollectionRName, id)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.reducerName)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.reducerName, queryParams))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksListAsOwner)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksListAsOwner/TasksListAsOwner.js